/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualSalaryDto } from '../../models/backend-actual-salary-dto';
import { BackendActualSalaryRequestDto } from '../../models/backend-actual-salary-request-dto';

export interface MonitoringActualsSalariesCreate$Params {
  /**
   * ID сценария для фильтрации списка
   */
  scenario_id?: number;

  /**
   * Поиск по текстовым полям сущности
   */
  search?: string;
  body: BackendActualSalaryRequestDto;
}

export function monitoringActualsSalariesCreate(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsSalariesCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualSalaryDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsSalariesCreate.PATH, 'post');
  if (params) {
    rb.query('scenario_id', params.scenario_id, {});
    rb.query('search', params.search, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualSalaryDto>;
    }),
  );
}

monitoringActualsSalariesCreate.PATH = '/api/monitoring/actuals/salaries/';
